import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { ButtonText } from '@powdr/constants';

export const AppFeedbackForm = ({
  captchaSiteKeyBasin,
  processForm,
  isUserVerified,
  setUserVerified,
  handleCaptchaExpiry,
  buttonText,
}) => {
  const captchaRef = useRef();

  return (
    <form id="app-feedback-form" onSubmit={(e) => processForm(e, 'buk_lyOGN7l85OFDQ4nClIlLMCwo', null, captchaRef)}>
      <h3>Email address *</h3>
      <input className="form-control" id="email" name="email" type="email" required="" />

      <h3>How was your experience with the Killington app? *</h3>
      <div className="multi-radio-field">
        <div className="radio-wrap">
          <input className="inline-radio" id="experienceRating" name="experienceRating" type="radio" required="" value="0" />
          <label className="inline-radio-label">0</label>
        </div>
        <div className="radio-wrap">
          <input className="inline-radio" id="experienceRating" name="experienceRating" type="radio" required="" value="1" />
          <label className="inline-radio-label">1</label>
        </div>
        <div className="radio-wrap">
          <input className="inline-radio" id="experienceRating" name="experienceRating" type="radio" required="" value="2" />
          <label className="inline-radio-label">2</label>
        </div>
        <div className="radio-wrap">
          <input className="inline-radio" id="experienceRating" name="experienceRating" type="radio" required="" value="3" />
          <label className="inline-radio-label">3</label>
        </div>
        <div className="radio-wrap">
          <input className="inline-radio" id="experienceRating" name="experienceRating" type="radio" required="" value="4" />
          <label className="inline-radio-label">4</label>
        </div>
        <div className="radio-wrap">
          <input className="inline-radio" id="experienceRating" name="experienceRating" type="radio" required="" value="5" />
          <label className="inline-radio-label">5</label>
        </div>
      </div>

      <h3>What version of the app are you using? *</h3>
      <div className="multi-radio-field">
        <div className="radio-wrap">
          <input className="inline-radio" id="osType" name="osType" type="radio" required="" value="iPhone (iOS)" />
          <label className="inline-radio-label">iPhone (iOS)</label>
        </div>
        <div className="radio-wrap">
          <input className="inline-radio" id="osType" name="osType" type="radio" required="" value="Android" />
          <label className="inline-radio-label">Android</label>
        </div>
      </div>

      <h3>Do you have any specific feedback for us? Please detail any issues you had using the app, features you'd like to see in the future, general critiques, etc.</h3>
      <textarea id="additionalComments" name="additionalComments" rows="9" />

      <ReCAPTCHA
        ref={captchaRef}
        className="recaptcha"
        sitekey={captchaSiteKeyBasin}
        theme="light"
        size="normal"
        onChange={() => setUserVerified(true)}
        onExpired={() => handleCaptchaExpiry()}
      />
      <button type="submit" value="Submit" disabled={!isUserVerified}>{buttonText || ButtonText.SUBMIT}</button>
    </form>
  );
};

AppFeedbackForm.propTypes = {
  captchaSiteKeyBasin: PropTypes.string.isRequired,
  processForm: PropTypes.func.isRequired,
  setUserVerified: PropTypes.func.isRequired,
  isUserVerified: PropTypes.bool.isRequired,
  handleCaptchaExpiry: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
};
